export default {
    header: 'Tests',
    unauthorized:
        "Tests are currently in closed beta. You don't have access to these features yet. They will be available soon!",
    error:
        'Something went wrong when trying to load the tests. Please try again later.',

    assessmentModule: {
        header: 'Your assessment',
    },

    completedYourProfile:
        'You need to complete your profile to get access to this assessment',
    toMyProfile: 'Edit my profile',

    tests: {
        comingSoon: 'Coming soon!',
        cute: {
            title: 'Cut-e workplace assessment',
            description:
                'Test your work-related behaviour, numerical reasoning, verbal reasoning and vocational interests and receive a comprehensive feedback report. Cut-e is considered the gold standard for graduate assessment in hiring processes.',
            action: `Start test`,
        },
        programming: {
            title: 'Programming tests',
        },
    },

    cute: {
        banner: {
            title:
                'How to get through the graduate recruitment selection process',
            description: `Test your work-related behaviour, numerical reasoning, verbal reasoning and vocational interests and receive a comprehensive feedback report. 
                            Cut-e is considered the gold standard for graduate assessment in hiring processes.`,
        },

        shortcuts: {
            header: 'Complete to see your score',
            seeYourScore: 'Click here to see your score',
        },

        dialog: {
            header: 'Start your Cut-e assessments',
            consent: `I understand that Cut-e (an AON company) is responsible for my data related to this assessment, and agree to their terms and conditions.
                    I also agree that Highered can transfer my name to Cut-e to generate my report.`,
        },

        logoCarousel: {
            header: 'Companies who trust in Cut-e for graduate assessment',
        },

        seeSampleReport: 'Download sample report',

        startTest: 'Start test',
        seeYourScore: 'See your score',

        measurementTitle: 'What does this assessment measure?',
        taskTitle: 'What is the task?',
        durationTitle: 'Duration',
        testTime: 'Approximately {minutes} minutes.',
        fullTestTime: 'Duration including instructions: {minutes} minutes',
        videoHeader: 'Video',
        watchVideo: 'Watch video',

        tests: {
            '102': {
                label: 'Work-related Behavior Test',
                measurement: `Identifies work-based personality characteristics and has been designed for use with graduates.`,
                task: `You are presented with 3 statements per page and must allocate up to 6 points across 
                these to reflect the extent to which you agree with each statement. 
                The questionnaire is based on 18 scales, each with 6 items and has been developed using adaptive techniques. 
                This means that statements are presented together based on your responses to earlier items. 
                This assessment is based on the "shapes management tool", with some items being changed and the final assessment being shorter in length.`,
            },
            '311': {
                label: 'Numerical Reasoning Test',
                measurement: 'Numerical reasoning',
                task: `You are presented with complex numerical information in tables and charts from which the you need to draw logical conclusions. 
                The look and feel of the test reflects common office software.
                Each test is created by a data-based test generation at run-time. This means that the assessment is different for each 
                test taker thereby helping to prevent cheating, which is important when running unsupervised online administrations.`,
            },
            '312': {
                label: 'Verbal Reasoning Test',
                measurement:
                    'The ability to draw logical conclusions from complex verbal information.',
                task: `You are presented with a range of written information and need to locate the relevant information, and 
                draw logical conclusions from this to answer the questions. The look and feel of the test reflects common office software.
                Each test is created by an item generator at run-time. This means that the assessment is different for each test taker thereby 
                helping to prevent cheating, especially important for unsupervised, online administration.`,
            },
            '606': {
                label: 'Vocational Interests and Motivation Test',
                measurement:
                    'Identifies aspirations and interests in a work setting.',
                task: `This assessment is divided into two parts. In the first, you will see statements describing typical work-related situations. On a scale
                of 3 options, you indicate how much you want situations like what is stated to take part in your work life. In the second section, you
                will se statements describing certain values in a work environment. You can allocate from 1 to 5 points to a statement - the more points
                you allocate, the more important you indicate this value is to you in a work situation.`,
            },
        },

        consentErrorTitle: 'Consent error',
        consentErrorMessage:
            'Something went wrong while submitting your consent. Please contact support.',
    },
};
